import { render, staticRenderFns } from "./RsaSchedaRelazioneSanitariaApparatoCardiocircolatorioEditComponent.vue?vue&type=template&id=e3dcb75a"
import script from "./RsaSchedaRelazioneSanitariaApparatoCardiocircolatorioEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaRelazioneSanitariaApparatoCardiocircolatorioEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports